import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const Assessments = lazy(() => import("../pages/Assessments"));

export const assessmentsRoutes = [
  {
    path: "/assessments",
    element: (
      <Suspense fallback={<LoadingFeedback />}>
        <Assessments />
      </Suspense>
    ),
  },
];
